import { httpGet } from '@inner-source/cis-shared/transports';

const getPagesByLabel = async ({ label, limit }) => httpGet('/get-pages-by-label', { label, limit });

export default getPagesByLabel;
